import React from "react";

import { VStack } from "@chakra-ui/react";

import { Journey } from "models/Journey";
import { UserProfile } from "models/UserProfile";

import FeaturesNotIncluded from "./FeaturesNotIncluded";
import ManageYourPlan from "./ManageYourPlan";
import YourPlanBenefits from "./YourPlanBenefits";
import YourPlanInfo from "./YourPlanInfo";
import YourTrips from "./YourTrips/YourTrips";

const BenefitsView: React.FC<{
  userProfile: UserProfile;
  journeys: Journey[];
}> = ({ userProfile, journeys }) => {
  return (
    <VStack alignItems="stretch" spacing={4}>
      <YourPlanInfo userProfile={userProfile} />
      {userProfile.policy.trip && journeys.length > 0 && <YourTrips journeys={journeys} />}
      {userProfile.policy.membership?.active && userProfile.policy.benefits && (
        <>
          <YourPlanBenefits benefits={userProfile.policy.benefits} eSim={userProfile.policy.perks.esim} />
          <FeaturesNotIncluded />
          <ManageYourPlan userProfile={userProfile} />
        </>
      )}
    </VStack>
  );
};

export default BenefitsView;
